import { render, staticRenderFns } from "./IconActivateDebtor.vue?vue&type=template&id=08764900&"
import script from "./IconActivateDebtor.vue?vue&type=script&lang=js&"
export * from "./IconActivateDebtor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports